import { useRequiredContext } from "@redotech/react-util/context";
import ReceiptCheckIcon from "@redotech/redo-icons/receipt-check.svg";
import ReceiptCheckFilledIcon from "@redotech/redo-icons/receipt-check_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useConversionLockedAction } from "../../../../conversion/locked/use-conversion-locked-action";

export const CheckoutItems = memo(function CheckoutItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { locked, onLockedClick } = useConversionLockedAction(
    ScheduleDemoButtonLocation.NAV_CHECKOUTS,
  );

  return (
    <RedoSecondaryNavItem
      action={
        locked
          ? { type: "button", onClick: onLockedClick }
          : { type: "link", href: routes.getConversionSubRoute("checkouts") }
      }
      dimmed={locked}
      FilledIcon={ReceiptCheckFilledIcon}
      friendlyName="Checkouts"
      id="checkouts"
      isPrivate={locked}
      UnfilledIcon={ReceiptCheckIcon}
    />
  );
});
